export const SEARCH_PLACEHOLDER = 'Search or ask anything';
export const SEARCH_WITH_FILTERS_PLACEHOLDER = `${SEARCH_PLACEHOLDER}, use <b class="clickable">;</b>for filters`;
export const CHAT_PAGE_PATH = 'chat';
export const UNLEASH_AI_CHAT_PATH = 'ai';
export const EXPLORE_ASSISTANTS_PATH = 'explore-assistants';
export const EXPLORE_ASSISTANTS_PATH_FULL_PATH = `/${CHAT_PAGE_PATH}/${EXPLORE_ASSISTANTS_PATH}`;
export const CONTROL_PAGE_PATH = 'control';
export const CHAT_PAGE_PATH_SESSION = 'c';
export const SIDE_PANEL_PAGE_PATH = 'side-panel';
export const SIDE_PANEL_CHAT_PAGE_PATH = `${SIDE_PANEL_PAGE_PATH}/chat`;
export const SIDE_PANEL_HOME_PAGE_PATH = `${SIDE_PANEL_PAGE_PATH}/home`;
export const SIDE_PANEL_SEARCH_PAGE_PATH = `${SIDE_PANEL_PAGE_PATH}/search`;
export const UNLEASH_AI_PATH = `/${CONTROL_PAGE_PATH}/unleash-ai`;
export const FORCE_RELOAD_CHAT = 'forceReloadChat';
